import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark" | "system";

interface ThemeState {
  theme: Theme;
  resolvedTheme: "light" | "dark";
  setTheme: (theme: Theme) => void;
  _resolve: () => void;
}

function resolveTheme(t: Theme): "light" | "dark" {
  if (t === "system") {
    return typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }
  return t;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: "light",
      resolvedTheme: "light",
      setTheme: (theme) => {
        set({ theme, resolvedTheme: resolveTheme(theme) });
        get()._resolve();
      },
      _resolve: () => {
        const t = get().theme;
        const resolved = resolveTheme(t);
        const root = document.documentElement;
        root.classList.toggle("dark", resolved === "dark");
      },
    }),
    { name: "paypilot.theme" },
  ),
);

if (typeof window !== "undefined") {
  useThemeStore.getState()._resolve();
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    useThemeStore.getState()._resolve();
  });
}
